<div class="payment-details-wrapper">
  <div class="status-row">
    <rms-select
      name="StatusID"
      class="status-select"
      [options]="statusDropdownOptions"
      labelKey="StatusName"
      valueKey="OrderPaymentStatusID"
      [disabled]="!CanEdit || Busy"
      [ngModel]="Payment.StatusID"
      (ngModelChange)="onStatusChange($event)">
    </rms-select>
  </div>

  <div class="detail-block">
    <h4>Overview</h4>
    <div class="detail-row"><span>Method</span><strong>{{ Payment.MethodName }}</strong></div>
    <div class="detail-row"><span>Status</span><strong>{{ Payment.StatusName }}</strong></div>
    <div class="detail-row"><span>Amount</span><strong>{{ Payment.Amount | currency }}</strong></div>
    <div class="detail-row"><span>Fee Amount</span><strong>{{ Payment.FeeAmount | currency }}</strong></div>
    <div class="detail-row"><span>Total Amount</span><strong>{{ Payment.TotalAmount | currency }}</strong></div>
    <div class="detail-row"><span>Transaction Reference</span><strong>{{ Payment.TransactionReference || '—' }}</strong></div>
    <div class="detail-row"><span>Masked Card/Account #</span><strong>{{ Payment.MaskedReference || '—' }}</strong></div>
    <div class="detail-row">
      <span>Receipt</span>
      @if (Payment.ReceiptBlobPath) {
        <button mat-button class="btn-link" (click)="viewReceipt()">
          View Receipt
        </button>
      } @else {
        <strong>Not generated yet</strong>
      }
    </div>
  </div>

  <div class="detail-block">
    <h4>Order Balance</h4>
    <div class="detail-row"><span>Order Total</span><strong>{{ Payment.OrderTotal | currency }}</strong></div>
    <div class="detail-row"><span>Paid on This Order</span><strong>{{ Payment.OrderPaid | currency }}</strong></div>
    <div class="detail-row"><span>Balance Due</span><strong>{{ Payment.OrderBalanceDue | currency }}</strong></div>
  </div>

  <div class="detail-block">
    <h4>Timeline</h4>
    <div class="timeline">
      @for (step of timelineSteps; track step.label) {
        <div class="timeline-step" [class.reached]="step.date">
          <span class="timeline-marker">{{ step.date ? '✓' : '○' }}</span>
          <div class="timeline-text">
            <span class="timeline-label">{{ step.label }}</span>
            @if (step.date) {
              <span class="timeline-date">{{ step.date | date:'short' }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <div class="detail-block">
    <h4>Customer Authorization</h4>
    <div class="detail-row"><span>Authorization Recipient Email</span><strong>{{ Payment.AuthorizationRecipientEmail || '—' }}</strong></div>
    @if (isAchPull) {
      <div class="detail-row"><span>Authorization Status</span><strong>{{ Payment.StatusName }}</strong></div>
      <div class="detail-row"><span>Authorization Requested Date</span><strong>{{ Payment.RequestedDate ? (Payment.RequestedDate | date:'short') : '—' }}</strong></div>
      <div class="detail-row"><span>Customer Authorized Date</span><strong>{{ Payment.CustomerAuthorizedDate ? (Payment.CustomerAuthorizedDate | date:'short') : '—' }}</strong></div>
    }
    <div class="detail-row"><span>Confirmation Sent Date</span><strong>{{ Payment.ConfirmationSentDate ? (Payment.ConfirmationSentDate | date:'short') : '—' }}</strong></div>
  </div>

  <div class="detail-block">
    <h4>Notes</h4>
    <p class="notes-text">{{ Payment.Notes || 'No notes recorded.' }}</p>
  </div>

  <div class="detail-history-panel">
    <h4>Audit History</h4>
    @if (LoadingHistory) {
      <p class="muted">Loading history...</p>
    } @else if (AuditHistory.length === 0) {
      <p class="muted">No history recorded.</p>
    } @else {
      @for (entry of AuditHistory; track entry.OrderActionHistoryID) {
        <div class="history-entry">
          <span class="history-action">{{ entry.ActionType }}</span>
          <span class="history-detail">{{ entry.ActionDetail }}</span>
          <span class="history-meta">{{ entry.ActionBy || 'System' }} &middot; {{ entry.ActionDate | date:'short' }}</span>
        </div>
      }
    }
  </div>
</div>
